// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_c5-a";
export var fulfillmentFormRail = "_c5-9";
export var headerTitleRow = "_c5-c";
export var orderDetailsWrapper = "_c5-7";
export var orderLinkTrigger = "_c5-2";
export var paymentInformationGrid = "_c5-h";
export var paymentSummaryColumn = "_c5-i";
export var shipmentContainer = "_c5-b";
export var shipmentDetailsMainPane = "_c5-8";
export var shipmentNavigationCard = "_c5-5";
export var shipmentNavigationRail = "_c5-3";
export var shipmentNavigationRailHeader = "_c5-4";
export var shipmentSummaryFact = "_c5-e";
export var shipmentSummaryGrid = "_c5-d";
export var shipmentSummaryMetadataRow = "_c5-f";
export var shipmentSummaryTags = "_c5-g";
export var shipmentWorkspace = "_c5-0";
export var shipmentWorkspaceContent = "_c5-6";
export var shipmentWorkspaceHeader = "_c5-1";